import script from "./BoxPanelLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxPanelLogin.vue?vue&type=script&setup=true&lang=js"

import "./BoxPanelLogin.vue?vue&type=style&index=0&id=5685bb7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5685bb7c"]])

export default __exports__